import { useLingui } from '@lingui/react/macro';
import { useMemo } from 'react';

import type { Subscription } from 'src/api/endpoints/storeApi.types';
import { formatDate, formatShortDate } from 'src/utils/formatDate';
import { formatAmount } from 'src/utils/productUtils';
import { subscriptionHasPaymentMethod } from 'src/utils/subscriptionPayment';

export const useFormattedPaymentInfo = (sub?: Subscription) => {
  const { t, i18n } = useLingui();
  const paymentInformation = useMemo(() => {
    if (!subscriptionHasPaymentMethod(sub)) {
      return null;
    }
    const payment = sub.paymentInformation.payment;

    const nextBillingDate = sub.paymentInformation.nextInvoice?.dueDate;

    const nextBilling = formatDate(nextBillingDate, { locale: i18n.locale });

    const nextBillingShort = formatShortDate(nextBillingDate, {
      locale: i18n.locale,
    });

    const amount = sub.paymentInformation.nextInvoice?.amount;
    const nextBillingAmount = amount
      ? formatAmount(amount.total, amount.currency, i18n.locale)
      : t`N/A`;

    if (payment.type === 'card') {
      return {
        type: 'card',
        details: {
          cardBrand: payment.details.brand.toUpperCase(),
          lastDigits: payment.details.last4,
          expireMonth: payment.details.expireMonth.toString().padStart(2, '0'),
          expireYear: payment.details.expireYear.toString().slice(-2),
          hasExpired: false, // TODO: Figure out if we need this
          wallet: payment.details.wallet,
        },
        nextBilling,
        nextBillingShort,
        nextBillingAmount,
      };
    }

    return {
      type: payment.type,
      details: payment.details,
      nextBilling,
      nextBillingShort,
      nextBillingAmount,
    };
  }, [sub, t, i18n.locale]);

  return paymentInformation;
};
